import type { VacationRange } from '../types';
import { fromJSON, toJSON } from './api';

const TTL_MS = 30 * 24 * 60 * 60 * 1000;

interface Entry {
  fetchedAt: number;
  data: ReturnType<typeof toJSON>;
}

function key(schoolYear: string): string {
  return `vac:${schoolYear}`;
}

export function getCached(schoolYear: string): VacationRange[] | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(key(schoolYear));
  if (!raw) return null;
  try {
    const entry = JSON.parse(raw) as Entry;
    if (Date.now() - entry.fetchedAt > TTL_MS) return null;
    return fromJSON(entry.data);
  } catch {
    return null;
  }
}

export function setCached(schoolYear: string, ranges: VacationRange[]): void {
  if (typeof localStorage === 'undefined') return;
  const entry: Entry = { fetchedAt: Date.now(), data: toJSON(ranges) };
  try {
    localStorage.setItem(key(schoolYear), JSON.stringify(entry));
  } catch {
    /* quota / private mode — silently ignore */
  }
}
